const NAMESPACE = "nameEntryModal";

const KEYS = {
    labelDefault: "labelDefault",
    emptyLabelWarning: "emptyLabelWarning",
    renameNote: "renameNote",
    duplicateNameError: "duplicateNameError",
    whitespaceError: "whitespaceError",
    invalidCharacterError: "invalidCharacterError",
    fileExtensionNotAllowedError: "fileExtensionNotAllowedError",
    newExtensionError: "newExtensionError"
};

const MESSAGES = {
    [KEYS.labelDefault]: {
        value: "New name",
        comment: "Default label for the new name input"
    },
    [KEYS.emptyLabelWarning]: {
        value: "{labelText} cannot be empty.",
        comment: "Warning when new name field is empty"
    },
    [KEYS.renameNote]: {
        value: "NOTE: This will affect all program design features that reference this definition. Project data will not be affected.",
        comment: "Note about the scope of the rename"
    },
    [KEYS.duplicateNameError]: {
        value: "An item with this name already exists. Please choose a different name.",
        comment: "Error when the rename choice is already is use"
    },
    [KEYS.whitespaceError]: {
        value: "This name cannot contain whitespace characters. Please choose a different name.",
        comment: "Error when new name contains invalid whitespace characters"
    },
    [KEYS.invalidCharacterError]: {
        value: "This name contains invalid characters: [{characterList}]. Please choose a different name.",
        comment: "Error when new name contains invalid characters along with a list of those characters"
    },
    [KEYS.fileExtensionNotAllowedError]: {
        value: "The new item name must not end with a file extension.",
        comment: "Error when attempting to rename with a file extension ending"
    },
    [KEYS.newExtensionError]: {
        value: "The new item name must end with the same file extension as the original name.",
        comment: "Error when attempting to change the file extension while renaming"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
